import { render, staticRenderFns } from "./SecurePayment.vue?vue&type=template&id=95b9b5fe&scoped=true&"
import script from "./SecurePayment.vue?vue&type=script&lang=js&"
export * from "./SecurePayment.vue?vue&type=script&lang=js&"
import style0 from "./SecurePayment.vue?vue&type=style&index=0&id=95b9b5fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b9b5fe",
  null
  
)

export default component.exports